import { useParams } from "react-router-dom";
import { useAlert, useApi } from "../hooks";
import { Fragment, useEffect, useState } from "react";
import constants from "../utils/constants";
import { useDevManager } from "../context";
import dateHelpers from "../utils/dateHelpers";
import { GoBack, PrimaryButton } from "../components/Buttons";
import { formatCurrency, triggerDownloadFromBlob } from "../utils/helpers";
import { formatPhoneNumber } from "react-phone-number-input";

function Invoice () {
    const alert = useAlert();
    const {fetch, getBinary} = useApi();
    let { id } = useParams();
    const { IS_DEV } = useDevManager();
    const [invoice, setInvoice] = useState({ items: []});
    const [account, setAccount] = useState({});

    useEffect(() => {
        fetchInvoice();
    }, [id]);
    
    useEffect(() => {
        fetchInvoiceAccount();
    }, [invoice]);

    function fetchInvoice() {
        fetch(`invoice/invoiceInfo/${id}`)
        .then(res => setInvoice(res))
        .catch(() => alert("Server error", "Unable to fetch invoice", "error"));
    }

    function fetchInvoiceAccount() {
        if(!invoice.id) return;
        fetch(`admin/SystemAccountInfo/${invoice.accountId}`)
        .then(res => setAccount(res))
        .catch(() => alert("Server Error", "Unable to fetch account information", "error"));
    }

    function downloadInvoice() {
        if (!invoice.id) return;
        getBinary(`report/GetInvoicePDF/${invoice.id}`)
        .then(res => {
            const blob = new Blob([res], { type: constants.MIME_TYPES.PDF,});
            triggerDownloadFromBlob(blob, `Invoice_${invoice.id}`);
        })
        .catch(err => { alert("Server Error", "Unable to download invoice", "error")});
    }

    return (
        <div>
            {/* {IS_DEV ? <div className="text-xl font-semibold">{`Invoice: ${id}`}</div> : null} */}
            <div className="flex flex-row justify-between my-4">
                <GoBack />
                <div className="flex shrink">
                    <PrimaryButton
                        text={"Download"}
                        onClick={downloadInvoice}
                    />
                </div>
            </div>
            <div className={"flex flex-col gap-4 p-4 rounded-lg border-2 border-black bg-white"}>
                <InvoiceRow>
                    <div className="flex flex-col">
                        <InvoiceLabel label={constants.APP_NAME} />
                        <div>{window.location.hostname}</div>
                        <div>ali@sightsource.net</div>
                        <div>{formatPhoneNumber("+1 3367824684")}</div>
                    </div>
                    <div className="font-bold">INVOICE</div>
                </InvoiceRow>
                <InvoiceRow>
                    <div className="flex flex-col">
                        <div><InvoiceLabel label={"Account:"} /> {invoice.accountName}</div>
                        <div><InvoiceLabel label={"Email:"} /> {account.email}</div>
                        <div><InvoiceLabel label={"Phone:"} /> {formatPhoneNumber(`+1 ${account.mobilePhone}`)}</div>
                    </div>
                    <div className="flex flex-col">
                    <div><InvoiceLabel label={"Invoice #"} /> {invoice.id}</div>
                        <div><InvoiceLabel label={"Billing Period"} /> {dateHelpers.formatDateToShortDate(invoice.dateFrom)} - {dateHelpers.formatDateToShortDate(invoice.dateTo)}</div>
                    </div>
                </InvoiceRow>
                <InvoiceRow>
                    <div>
                        <InvoiceLabel label={"Transactions"} />
                    </div>
                    <div/>
                </InvoiceRow>
                <div className="grid grid-cols-7 gap-4 text-xl">
                    <div className=""><InvoiceLabel label={"Date"} /></div>
                    <div className="col-span-2"><InvoiceLabel label={"System Tenant"} /></div>
                    <div className=""><InvoiceLabel label={"Type"} /></div>
                    <div className="flex flex-wrap justify-end"><InvoiceLabel label={"Amount"} /></div>
                    <div className="flex flex-wrap justify-end"><InvoiceLabel label={"Fee"} /></div>
                    <div className="flex flex-wrap justify-end"><InvoiceLabel label={"Fee Amount"} /></div>
                    {invoice.items.map((item) => {
                        return (
                            <Fragment key={`item-${item.id}`}>
                                <div className="">{dateHelpers.formatDateToShortDate(item.paymentDate)}</div>
                                <div className="col-span-2">{item.systemTenantName}</div>
                                <div className="">{item.paymentTypeName}</div>
                                <div className="flex flex-wrap justify-end">{formatCurrency(item.paymentAmount, true)}</div>
                                <div className="flex flex-wrap justify-end">{item.margotFee?.toLocaleString(undefined,{style: 'percent', minimumFractionDigits:2})}</div>
                                <div className="flex flex-wrap justify-end">
                                    <InvoiceLabel label={formatCurrency(item.margotFeeAmount, true)} />
                                </div>
                            </Fragment>
                        )
                    })}
                </div>
                <InvoiceRow>
                    <div/>
                    <div className="flex flex-col">
                        <div className="flex flex-row justify-between gap-x-10"><InvoiceLabel label={"Processed Transactions Total"}/> {formatCurrency(invoice.total, true)}</div>
                        <div className="flex flex-row justify-between gap-x-10">
                            <InvoiceLabel label={"Total Processing Fees Charged"}/> 
                            <InvoiceLabel label={formatCurrency(invoice.feeTotal, true)} />
                        </div>
                    </div>
                </InvoiceRow>
            </div>
        </div>
    );
}

function InvoiceRow({children, key}) {
    return (
        <div key={key} className="flex flex-row justify-between text-xl">
            {children}
        </div>
    )
}

function InvoiceLabel({label}) {
    return <span className="font-semibold">{label}</span>
}

export default Invoice;